'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$BankAccountNumber$() {
  this.aEc = null;
  this.aEd = false;
}
export { $c_Lapp_data_PaymentDetails$package$BankAccountNumber$ as $c_Lapp_data_PaymentDetails$package$BankAccountNumber$ };
$p = $c_Lapp_data_PaymentDetails$package$BankAccountNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_PaymentDetails$package$BankAccountNumber$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$BankAccountNumber$() {
}
export { $h_Lapp_data_PaymentDetails$package$BankAccountNumber$ as $h_Lapp_data_PaymentDetails$package$BankAccountNumber$ };
$h_Lapp_data_PaymentDetails$package$BankAccountNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aEd)) {
    this.aEc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aEd = true;
  }
  return this.aEc;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_PaymentDetails$package$BankAccountNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$BankAccountNumber$, "app.data.PaymentDetails$package$BankAccountNumber$", ({
  EC: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_PaymentDetails$package$BankAccountNumber$ as $d_Lapp_data_PaymentDetails$package$BankAccountNumber$ };
var $n_Lapp_data_PaymentDetails$package$BankAccountNumber$;
function $m_Lapp_data_PaymentDetails$package$BankAccountNumber$() {
  if ((!$n_Lapp_data_PaymentDetails$package$BankAccountNumber$)) {
    $n_Lapp_data_PaymentDetails$package$BankAccountNumber$ = new $c_Lapp_data_PaymentDetails$package$BankAccountNumber$();
  }
  return $n_Lapp_data_PaymentDetails$package$BankAccountNumber$;
}
export { $m_Lapp_data_PaymentDetails$package$BankAccountNumber$ as $m_Lapp_data_PaymentDetails$package$BankAccountNumber$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-Bank-Account-Number$.js.map
